__turbopack_context__.v({
  "logo-image-wrapper": "styles-module__G2Vzua__logo-image-wrapper",
});
